<template lang="pug">
  v-flex(:xs6="!mobile" :column="mobile" :style="{'padding': (!mobile) ? '32px 10px 15px 25px' : '20px 2%'}" style="overflow: hidden")
    v-card-title(style="white-space: nowrap")
      p.title
        b {{currentStep > 2 ? $t('auth.finishFirstLogin') : $t('auth.firstLogin')}}
      v-stepper(:value="currentStep" style="box-shadow: none" id="firstSettingStepper" v-show="currentStep <= 2")
        v-stepper-header(style="height: 30px;")
          v-stepper-step(color="achGreen2" v-for="item in stepper" :key="item.text" :step="item.step" :complete="item.status") {{$t('auth.firstLoginSteps.' + item.name)}}
    v-card-text(:class="{'py-4 pr-4': !mobile}" v-if="currentStep === 1")
      v-form.pr-4
        v-text-field(prepend-icon="lock"
                      name="newPassword"
                      :label="$t('auth.resetPw.newPassword')"
                      type="password"
                      v-model="changePwInfo.newPassword"
                      light
                      color="black"
                      :error-messages="errors.collect('newPassword')"
                      v-validate="'required|customPassword'"
                      data-vv-as=" "
                      maxlength="16"
                      @keyup.enter="btnEvent('')")
        v-text-field(prepend-icon="lock"
                      name="confirmPassword"
                      :label="$t('auth.resetPw.confirmPassword')"
                      type="password"
                      v-model="changePwInfo.confirmPassword"
                      light
                      color="black"
                      :error-messages="errors.collect('confirmPassword')"
                      v-validate="{required: true, is: changePwInfo.newPassword}"
                      data-vv-as=" "
                      maxlength="16"
                      @keyup.enter="btnEvent('')")
    v-card-text(v-else-if="currentStep === 2")
      v-layout.mr-3(justify-center style="height: 120px")
        div(style="position:relative")
          v-icon(style="font-size: 120px;color: #C8C7CC" v-if="!image.url") account_circle
          v-avatar(:size="100"
                    color="grey lighten-4"
                    style="margin: 10px"
                    v-else)
            img(:src="image.url" alt="avatar")
          v-btn.upload-img-icon(icon dark @click="$refs.imageUpload.click()")
            v-icon(style="font-size: 20px" color="white") camera_alt
          input(type="file"
                style="display: none"
                ref="imageUpload"
                name="imageUpload"
                accept="image/jpg,image/png"
                v-validate="'required'"
                @change="onFilePicked"
                @click="$event.target.value = ''")
      v-layout.pt-3(column :class="!errors.first('imageUpload') && !image.err ? 'achBlack2--text' : 'achRed--text'")
        v-flex 接受JPG、PNG 格式，檔案大小 1 MB 以內
        v-flex 建議尺寸為 85*85 px，長寬比例 1:1
    v-card-text(style="padding-bottom: 45px;" v-else)
      v-list
        v-list-tile(v-for="item in stepperOptions" :key="item.text")
          v-list-tile-action
            v-icon {{(item.status) ? 'check' : 'clear'}}
          v-list-tile-content
            v-list-tile-sub-title.achBlack2--text {{item.status ? $t('auth.firstLoginSteps.' + item.name + 'Success') : $t('auth.firstLoginSteps.' + item.name + 'Fail')}}
      p.achGray4--text(style="padding-left: 56px") 提示：{{seconds}} 秒後自動前往登入。
    v-card-actions.py-4.px-0
      v-layout.pr-5(column)
        v-flex.pl-5(v-if="currentStep === 1")
          v-btn.elevation-3.white--text(round block dark color="achBlack" style="height: 48px;margin: 0;" @click="btnEvent('changePw')" :loading="loading")
            span.white--text(style="font-size: 18px") {{$t('auth.btns.confirm')}}
        v-flex.pl-3(v-else-if="currentStep === 2")
          v-layout(row align-center)
            v-btn.elevation-3.white--text.mr-4(round block dark color="achBlack" style="height: 48px;margin: 0;" @click="btnEvent('uploadImg')" :loading="loading")
              span.white--text(style="font-size: 18px") {{$t('auth.btns.submit')}}
            span(style="cursor: pointer;" @click="btnEvent('skipImg')") 略過
        v-flex(:style="{'padding-left': !mobile ? '70px' : '50px'}" v-else)
          v-btn.elevation-3.white--text(round block dark color="achBlack" style="height: 48px;margin: 0;" @click="btnEvent('backToLogin')" :loading="loading")
            span.white--text(style="font-size: 18px") {{$t('auth.btns.backToLogin')}}
</template>

<script>
import { global } from 'mixins/global'
import cryptoEvents from '@/events/cryptoEvents'

export default {
  mixins: [global],
  props: {
    mobile: {
      type: Boolean,
      default: false
    },
    password: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      currentStep: 1,
      stepperOptions: [
        {step: 1, name: 'changePw', text: 'auth.firstLoginSteps.changePw', status: false},
        {step: 2, name: 'uploadImg', text: 'auth.firstLoginSteps.uploadImg', status: false}
      ],
      changePwInfo: {
        newPassword: '',
        confirmPassword: '',
        passwordCode: '',
        isSuccessReset: false,
        isExpired: false,
        errMsg: ''
      },
      timer: null,
      seconds: 6,
      image: {
        name: '',
        file: '',
        url: '',
        err: false
      }
    }
  },
  computed: {
    authStatus () {
      return this.$store.getters.authStatus
    },
    stepper: {
      get () {
        this.stepperOptions.forEach(item => {
          if (this.currentStep > item.step) {
            item.status = true
          }
        })
        return this.stepperOptions
      },
      set (value) {
        let result = this.stepperOptions.find(item => item.step === value.step)
        result.status = value.status
      }
    }
  },
  mounted () {
  },
  methods: {
    btnEvent (event) {
      switch (event) {
        case 'changePw':
          this.$validator.validateAll()
            .then((result) => {
              if (result) {
                this.loading = true
                let params = {
                  oldPassword: this.password,
                  newPassword: cryptoEvents.createHash(this.changePwInfo.newPassword)
                }
                this.$store.dispatch('changePw', {params: params})
                  .then(response => {
                    this.loading = false
                    this.currentStep = 2
                  })
                  .catch(err => {
                    if (typeof err.response === 'undefined' || err.response.status !== 400) this.$store.dispatch('errorsHandler', {params: err})
                    else this.changePwInfo.errMsg = this.$t('errors.originPwError')
                  })
              }
            })
          break
        case 'uploadImg':
          this.$validator.validateAll({imageUpload: this.image.url})
            .then((result) => {
              if (result) {
                this.image.err = false
                this.loading = true
                let userInfo = this.$store.getters.getUserInfo
                let tenantId = userInfo.service + '-' + userInfo.brandName
                let keyName = (!this.$store.getters.getEnvParams ? 'dev' : this.$store.getters.getEnvParams.envMode) + '/' + userInfo.account + '-' + tenantId + '/' + this.image.file.name
                let params = {
                  key: keyName,
                  file: this.image.file
                }
                this.$store.dispatch('uploadImg', {params: params})
                  .then(response => {
                    console.log(response)
                    this.currentStep = 3
                    this.loading = false
                    this.$store.commit('SET_USER_IMG', response.data.path)
                  })
                  .catch(err => {
                    console.log(err)
                  })
              }
            })
          break
        case 'skipImg':
          if (!this.loading) {
            this.currentStep = 3
            this.$nextTick(() => {
              this.stepper = {step: 2, status: false}
            })
          }
          break
        case 'backToLogin':
          clearTimeout(this.timer)
          this.$emit('btnEvent', {action: 'backToLogin'})
          break
      }
    },
    countdown () {
      this.seconds--
      if (this.seconds <= 0) {
        clearTimeout(this.timer)
        this.$emit('btnEvent', {action: 'backToLogin'})
      } else {
        this.timer = setTimeout(this.countdown, 1000)
      }
    },
    onFilePicked (e) {
      let files = e.target.files
      if (files[0] !== undefined) {
        if (files[0].size <= 1024 * 1024 && (files[0].type === 'image/jpeg' || files[0].type === 'image/png')) {
          this.image.name = files[0].name
          if (this.image.name.lastIndexOf('.') <= 0) {
            return
          }
          let fr = new FileReader()
          fr.readAsDataURL(files[0])
          fr.addEventListener('load', () => {
            this.image.err = false
            this.image.url = fr.result
            this.image.file = files[0]
          })
        } else {
          this.image.err = true
        }
      } else {
        this.image.name = ''
        this.image.file = ''
        this.image.url = ''
      }
    }
  },
  watch: {
    'currentStep' (value) {
      if (value === 3) {
        this.countdown()
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  #firstSettingStepper /deep/
    .v-stepper__header
      box-shadow: none
      flex-wrap: nowrap
      justify-content: flex-start
    .v-stepper__step
      padding: 0 30px 0 0
      font-size: 13px
    .v-stepper__label
      display: block
    .v-stepper__step__step
      margin-right: 8px

  .upload-img-icon
    border-radius: 50px
    background: #000
    position: absolute !important
    right: 0
    bottom: 0
    margin: 0 8px 8px 0
    width: 40px
    height: 40px
    border: 1px solid #fff

  #stepperResult /deep/
    .v-list__tile
      padding-left: 0
      height: auto
      min-height: 48px
    .v-list__tile__sub-title
      white-space: normal
</style>
